import { cloneDeep } from "lodash-es";

import { Flags } from "views/flags";

import { DefaultDashboardTabs } from "./constants";
import { DashboardColumns, DashboardConfig, Widget } from "./types";
import { getAllDashboardWidgets, getDashboardsWidgetsByTab, getInitialConfig } from "./helpers";

export const validateConfig =
  (flags: Partial<Flags> | undefined, isAdmin: boolean) => (oldConfig: DashboardConfig) => {
    const newConfig = cloneDeep(oldConfig);

    const dashboardWidgetsByTab = getDashboardsWidgetsByTab(flags, isAdmin);
    const allDashboardWidgets = getAllDashboardWidgets(flags, isAdmin);

    // Add default tabs missing from the saved config
    const defaultConfig = getInitialConfig(flags, isAdmin);
    (Object.keys(defaultConfig) as Array<keyof typeof defaultConfig>).forEach((tabKey) => {
      if (!newConfig[tabKey] && defaultConfig[tabKey]) {
        newConfig[tabKey] = defaultConfig[tabKey];
      }
    });

    Object.keys(newConfig).map((key) => {
      const allowedWidgets =
        key in dashboardWidgetsByTab
          ? dashboardWidgetsByTab[key as DefaultDashboardTabs]
          : allDashboardWidgets;

      const allowedWidgetsKeys = Object.keys(allowedWidgets) as Widget[];

      const conf = [...newConfig[key].left, ...newConfig[key].right];
      const currentWidgets = conf.map(({ value }) => value);

      const promoted: DashboardColumns["left"] = [];

      allowedWidgetsKeys.forEach((widgetKey) => {
        if (!currentWidgets.includes(widgetKey)) {
          const item = {
            value: widgetKey,
            hidden: allDashboardWidgets[widgetKey]?.hidden,
          };

          if (allDashboardWidgets[widgetKey]?.promoteToTop) {
            promoted.push(item);
          } else {
            newConfig[key].left.push(item);
          }
        }
      });

      newConfig[key].left.unshift(...promoted);

      currentWidgets.forEach((currentWidgetKey) => {
        if (!allowedWidgetsKeys.includes(currentWidgetKey)) {
          const left = newConfig[key].left.findIndex(({ value }) => value === currentWidgetKey);
          if (left > -1) {
            newConfig[key].left.splice(left, 1);
          } else {
            const right = newConfig[key].right.findIndex(({ value }) => value === currentWidgetKey);
            if (right > -1) {
              newConfig[key].right.splice(right, 1);
            }
          }
        }
      });
    });

    return newConfig;
  };
